mutation AddEntityApprover($input: AppendEntityApproverInput!) {
  appendEntityApprover(input: $input) {
    clientMutationId
    approvalHistoryBranch {
        id
        approverName
        _rowTimestamp
        statusTypeId
        comments
      }
  }
}
